export default __webpack_public_path__ + "e038d48cc8e4773c575241e454fb94e4.png";